import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog"; // removed DialogFooter
import { Button } from "../ui/button";

const DeleteModal = ({ isOpen, closeModal, handleDeleteAction, itemId }) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeModal()}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader className="">
          <DialogTitle>Are you sure you want to delete this item?</DialogTitle>
          <DialogDescription className="my-2"> 
            This item will be permanently deleted. You cannot undo this action.
          </DialogDescription>
        </DialogHeader>

        {/* Use a simple div instead of DialogFooter */}
        <div className="flex justify-center gap-4 mt-4">
          <Button
            variant="outline"
            onClick={closeModal}
            className="w-24 border-primary text-primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDeleteAction(itemId);
              closeModal();
            }}
            className="w-24 bg-danger text-white hover:bg-danger/90"
          >
            Delete
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteModal;
